import { initializeScripts } from './js/utils/scriptsLoader';

document.addEventListener("DOMContentLoaded", initializeScripts);